/** Extract a user-visible message from a FastAPI/axios error response. */
export function apiErrorMessage(error, fallback = 'Request failed.') {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const parts = detail.map((item) => {
      const loc = Array.isArray(item.loc)
        ? item.loc.filter((part) => part !== 'body').join('.')
        : '';
      const msg = (item.msg || '').replace(/^Value error,\s*/i, '');
      return loc ? `${loc}: ${msg}` : msg;
    }).filter(Boolean);
    return parts.join(' ') || fallback;
  }
  return fallback;
}
